import { render, staticRenderFns } from "./ProjectTasksPrioritySelect.vue?vue&type=template&id=4e31de5e&scoped=true"
import script from "./ProjectTasksPrioritySelect.vue?vue&type=script&lang=js"
export * from "./ProjectTasksPrioritySelect.vue?vue&type=script&lang=js"
import style0 from "./ProjectTasksPrioritySelect.vue?vue&type=style&index=0&id=4e31de5e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e31de5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e31de5e')) {
      api.createRecord('4e31de5e', component.options)
    } else {
      api.reload('4e31de5e', component.options)
    }
    module.hot.accept("./ProjectTasksPrioritySelect.vue?vue&type=template&id=4e31de5e&scoped=true", function () {
      api.rerender('4e31de5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/ProjectTasksPrioritySelect.vue"
export default component.exports